/**
 * 合作申请api
 */
export default {
  // 招商加盟-合作申请-申请列表
  selectCompanyApplyInfoList: '/companyApply/selectCompanyApplyInfoList',
  // 招商加盟-合作申请
  insertCompanyApplyInfo: '/companyApply/insertCompanyApplyInfo',
  // 合作申请-申请详情
  selectCompanyApplyInfoDetail:'/companyApply/selectCompanyApplyInfoDetail',
};
